<template>
     <div class="whAll">
          <router-view></router-view>
     </div>
     
</template> 
<script>
    export default {
        
        data () {
            return {  
                 
            };
            
        }, 
        computed: {
        
        },
        methods: {
             
        },
        mounted: function(){
            var that = this;   
        }
    }
</script>  
<style scoped>
    
</style>